function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "4.4b-\\u2013-Library-[BY-SEARCH]",
  transform: "translate(-947.000000, -457.000000)"
}, React.createElement("g", {
  id: "Cross-Copy",
  transform: "translate(948.000000, 458.000000)"
}, React.createElement("path", {
  d: "M13.3354037,4.66457734 C13.115942,4.44514089 12.7639752,4.44514089 12.5445135,4.66457734 L9,8.20868315 L5.45548654,4.66457734 C5.23602484,4.44514089 4.88405797,4.44514089 4.66459627,4.66457734 C4.44513458,4.8840138 4.44513458,5.2359402 4.66459627,5.45537665 L8.20910973,8.99948246 L4.66459627,12.5435883 C4.44513458,12.7630247 4.44513458,13.1149511 4.66459627,13.3343876 C4.77225673,13.4420357 4.91718427,13.5 5.05797101,13.5 C5.19875776,13.5 5.3436853,13.446176 5.45134576,13.3343876 L8.99585921,9.79028177 L12.5403727,13.3343876 C12.6480331,13.4420357 12.7929607,13.5 12.9337474,13.5 C13.0786749,13.5 13.2194617,13.446176 13.3271222,13.3343876 C13.5465839,13.1149511 13.5465839,12.7630247 13.3271222,12.5435883 L9.79089027,8.99948246 L13.3354037,5.45537665 C13.5548654,5.2359402 13.5548654,4.8840138 13.3354037,4.66457734 Z",
  id: "Path",
  fill: "#FF4D4D",
  fillRule: "nonzero"
}), React.createElement("rect", {
  id: "Rectangle",
  stroke: "#FF4D4D",
  strokeWidth: 0.5,
  x: -0.25,
  y: -0.25,
  width: 18.5,
  height: 18.5,
  rx: 2
}))));

var SvgCrossSquare = function SvgCrossSquare(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCrossSquare, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cross-square.893db73e.svg";
export { ForwardRef as ReactComponent };